const initialState = Date.now();

export default (state = initialState, action) => {
    switch (action.type) {
        case "UPDATE_TIMESTAMP":
            return Date.now();
        default: return state;
    };
};